const SEPARATOR = ':'

export const useStorage = (initStorage: Storage) => {
  const storage = initStorage

  const getStorage = (keys: number | string | (string | number | undefined)[]) => {
    const parsedKey = Array.isArray(keys) ? keys?.join(SEPARATOR) : String(keys) || ''
    return storage.getItem(parsedKey)
  }

  const setStorage = (keys: number | string | (string | number | undefined)[], value: string | number) => {
    const parsedKey = Array.isArray(keys) ? keys?.join(SEPARATOR) : String(keys) || ''
    return storage.setItem(parsedKey, String(value))
  }

  const removeStorage = (keys: number | string | (string | number | undefined)[]) => {
    const parsedKey = Array.isArray(keys) ? keys?.join(SEPARATOR) : String(keys) || ''
    return storage.removeItem(parsedKey)
  }

  const clearStorage = () => {
    storage.clear()
  }

  /**
   * key 값을 얻은 후 해당 key/value 를 삭제한다.
   * 
   * @param keys 
   * @returns 
   */
  const getAndRemoveStorage = (keys: number | string | (string | number | undefined)[]) => {
    const value = getStorage(keys);
    removeStorage(keys);

    return value;
  }


  return {
    getStorage,
    setStorage,
    removeStorage,
    clearStorage,
    getAndRemoveStorage
  }
}

export const useLocalStorage = () => {
  return useStorage(localStorage)
}

export const useSessionStorage = () => {
  return useStorage(sessionStorage)
}

export default useStorage
